<template>
	<div class="interval"></div>
</template>

<script>
export default {
	name: 'interval'
}
</script>

<style scoped>
.interval {
	width: calc(100% + 60px);
	height: 15px;
	margin-left: -30px;
	background: #f1f1f1;
}
</style>
